<template>
    <div class="shop-wrapper">
        <div id="orders-list" class="section">
            <!-- Container -->
            <div class="container">

                <!-- Orders List -->
                <div class="columns account-header category-header">
                    <div class="column main-column is-tablet-landscape-padded">
                        <div class="account-title">
                            <h2>Carrito</h2>
                            <img :src="require('../../assets/images/icon-bambi.png')" alt="brand-filigrane" class="brand-filigrane">
                        </div>

                        <!-- Controls -->
                         <div class="listing-controls">
                        </div>
                        <!-- /Controls -->

                        <div id="orders-empty-placeholder" class="main-placeholder" v-if="!cartLoading && cart.cart == null">
                            <div class="placeholder-content">
                                <h3>No Tiene Items en el Carrito</h3>
                                <p>No hay items para mostrar. El detalle del carrito mostrará aquí, a partir del momento en que agregue algún item.</p>
                            </div>
                        </div>

                        <!-- Product List -->
                        <div class="columns is-product-list is-multiline" v-else>
                            <div class="column is-12">

                                <!-- Cart Layout -->
                                <div class="columns is-account-grid is-multiline">
                                    <!--Loader-->
                                    <div class="account-loader" :class=" cartLoading ? 'is-active' : '' ">
                                        <div class="loader is-loading"></div>
                                    </div>

                                    <!-- Cart list -->
                                    <div id="cart-page-products" class="column is-8" v-if="!cartLoading">

                                        <div class="flat-card is-auto cart-card product-container"
                                            v-for="detail in cartDetail"
                                            v-bind:key="`data-product-${detail.codigo}`">
                                            <ul class="cart-content">
                                                <li>
                                                    <img :src="require('../../assets/images/icon-bambi.png')">
                                                    <span class="product-info">
                                                        <span>{{ detail.modelo}}</span>
                                                        <span>Cod.: {{detail.codigo}}</span>
                                                    </span>
                                                    <span class="product-price">
                                                        <span>Precio</span>
                                                        <span>{{ detail.precio | MoneyFormat }}</span>
                                                    </span>

                                                    <div data-trigger="spinner" class="main-cart-spinner">
                                                        <input class="hidden-spinner" type="hidden" value="16" data-spin="spinner" data-rule="quantity" data-min="1" data-max="99">
                                                        <a class="spinner-button is-remove" href="javascript:;" data-spin="down" @click="remove(detail.codigo)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                                stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus">
                                                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                                            </svg>
                                                        </a>

                                                        <input class="spinner-value" type="text" name="" v-model="detail.cantidad" @change="updateItem(detail.codigo, 'change', detail.cantidad)">

                                                        <a class="spinner-button is-add" href="javascript:;" data-spin="up" @click="add(detail.codigo)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                                stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus">
                                                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                                            </svg>
                                                        </a>
                                                    </div>

                                                    <span class="action">
                                                        <span class="action-link is-remove remove-from-cartpage-action has-simple-popover"
                                                            data-content="Remove from Cart" data-placement="top" onclick="return false">
                                                            <a @click="confirmCustomDelete(detail.codigo)">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                                    stroke-linejoin="round" class="feather feather-trash-2">
                                                                    <polyline points="3 6 5 6 21 6"></polyline>
                                                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                                                    <line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                                                                </svg>
                                                            </a>
                                                        </span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                    <!-- /Cart list -->

                                    <!--Cart Summary-->
                                    <div class="column is-4" v-if="!cartLoading && deductions != null">
                                        <div class="flat-card cart-order-summary">

                                            <div class="summary-header">
                                                <span>Forma de Pago</span>
                                            </div>
                                            <div class="cart-summary-list">
                                                <div class="summary-item">
                                                    <span>Pago: </span>
                                                    <span id="cart-summary-subtotal" >
                                                        <b-select placeholder="Elija forma de pago" v-model="formaPago" @input="setPayment(formaPago)">
                                                            <option
                                                                v-for="payment in deductions.formas_pago"
                                                                :value="payment.Codigo"
                                                                :key="payment.Codigo">
                                                                {{ payment.Detalle +" %" }} {{ payment.Dto | MoneyFormat}}
                                                            </option>
                                                        </b-select>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="summary-header">
                                                <span>Descuento Pago Anticipado % {{ deductions.dto_pago_anticipado.Dto | MoneyFormat}}</span>
                                            </div>
                                            <div class="cart-summary-list">
                                                <div class="summary-item">
                                                    <span>Pago Anticipado Activado: </span>
                                                    <span>
                                                        <b-switch v-model="pagoAnticipado"
                                                            type="is-success"
                                                            size="is-small"
                                                            true-value="true"
                                                            false-value="false"
                                                            @input="setPrepaid(pagoAnticipado)">
                                                        </b-switch>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="summary-header">
                                                <span>Deducciones por Volumen</span>
                                            </div>
                                            <div class="cart-summary-list">
                                                <div class="summary-item"
                                                    v-for="vol in deductions.dtos_volumen" v-bind:key="`data-discount-vol-${vol.registro}`"
                                                    :class="vol.Dto == cart.cart.dto_volumen ? 'active' : '' ">
                                                    <span>Desde {{vol.Cantidad}} unidades</span>
                                                    <span class="discount">
                                                        {{ vol.Dto | MoneyFormat}}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="summary-header header-only" v-if="deductions.dto_adicional.Dto > 0">
                                                <span>Descuento Adicional % {{ deductions.dto_adicional.Dto | MoneyFormat}}</span>
                                            </div>
                                            <div class="summary-header">
                                                <span>Observación</span>
                                            </div>
                                            <div class="cart-summary-list">
                                                <b-input maxlength="200" type="textarea" v-model="cart.cart.observacion" @input="handleKeydown(cart.cart.observacion)"></b-input>
                                            </div>
                                        </div>

                                        <div class="flat-card cart-order-summary" v-if="cart.cart != null">
                                            <div class="button-wrap">
                                                <div class="summary-header">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                                                    <div>
                                                        <var id="cart-page-count">
                                                            {{ cart.cart.items_totales }}
                                                        </var>
                                                        <span v-if="cart.cart.items_totales == 1">Item en Carrito</span>
                                                        <span v-else>Item(s) en Carrito</span>
                                                    </div>
                                                </div>
                                                <div class="cart-summary-list">
                                                    <div class="summary-item">
                                                        <span>Subtotal</span>
                                                        <span id="cart-summary-subtotal" class="amount">
                                                            {{ cart.cart.sub_total | MoneyFormat }}
                                                        </span>
                                                    </div>
                                                    <div class="summary-item" v-if="cart.cart.monto_forma_pago">
                                                        <span>Dto. Financiero (% {{cart.cart.dto_forma_pago | MoneyFormat }})</span>
                                                        <span id="cart-summary-taxes" class="amount">
                                                            {{ cart.cart.monto_forma_pago | MoneyFormat }}
                                                        </span>
                                                    </div>
                                                    <div class="summary-item" v-if="cart.cart.monto_anticipo">
                                                        <span>Dto. Anticipo (% {{cart.cart.dto_pago_anticipado | MoneyFormat }})</span>
                                                        <span id="cart-summary-taxes" class="amount">
                                                            {{ cart.cart.monto_anticipo | MoneyFormat }}
                                                        </span>
                                                    </div>
                                                    <div class="summary-item" v-if="cart.cart.monto_volumen">
                                                        <span>Dto. Volumen (% {{cart.cart.dto_volumen | MoneyFormat }})</span>
                                                        <span id="cart-summary-taxes" class="amount">
                                                            {{ cart.cart.monto_volumen | MoneyFormat }}
                                                        </span>
                                                    </div>
                                                    <div class="summary-item" v-if="cart.cart.monto_dto_adicional">
                                                        <span>Dto. Adicional (% {{cart.cart.dto_adicional | MoneyFormat }})</span>
                                                        <span id="cart-summary-taxes" class="amount">
                                                            {{ cart.cart.monto_dto_adicional | MoneyFormat }}
                                                        </span>
                                                    </div>
                                                    <div class="summary-item" v-if="cart.cart.monto_total_dto">
                                                        <span>Dto. Total</span>
                                                        <span id="cart-summary-taxes" class="amount">
                                                            {{ cart.cart.monto_total_dto | MoneyFormat }}
                                                        </span>
                                                    </div>
                                                    <div class="summary-item is-bold">
                                                        <span>Total *</span>
                                                        <span id="cart-summary-total" class="amount">
                                                            {{ cart.cart.total | MoneyFormat }}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="button-container">
                                                    <button id="init-checkout" v-show="cartEquals" @click="checkAndConfirmCart()"
                                                        :class="cartActionLoading ? 'is-loading' : ''"
                                                        class="button is-fullwidth feather-button is-bold primary-button raised is-rounded">
                                                        Finalizar Carrito
                                                    </button>

                                                    <button id="update-cart-page" v-show="!cartEquals" @click="updateCart(cartDetail)"
                                                        :class="cartActionLoading ? 'is-loading' : ''"
                                                        class="button is-fullwidth feather-button is-bold secondary-button raised is-rounded">
                                                        Actualizar Carrito
                                                    </button>

                                                </div>
                                                <div class="button-container">
                                                    <button id="delete-cart-page" @click="deleteCart()"
                                                        :class="cartActionLoading ? 'is-loading' : ''"
                                                        class="button is-fullwidth feather-button is-bold delete-button raised is-rounded">
                                                        Eliminar Carrito
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="content is-small">* La presente liquidación <b>No incluye la liquidación de Percepción de IIBB.</b></span>
                                    </div>
                                    <!--/Cart Summary-->

                                </div>
                                <!-- /Cart Layout -->
                            </div>
                        </div>
                        <!-- Cart list -->

                    </div>
                </div>
                <!-- /Orders List -->
            </div>
            <!-- /Container -->
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
    name: 'orderIntentions',
    beforeCreate(){
        this.$store.dispatch('cart/getCart')
        this.$store.dispatch('deductions/getDeductions')
    },
    created() {
        this.handleKeydown = _.debounce(this.handleKeydown, 3000)
    },
    data() {
        return {
            formaPago: null,
            observacion: null,
            pagoAnticipado: false,
            cartEquals: true,
            cartDetail: []
        }
    },
    computed: {
        ...mapGetters({
            deductions: 'deductions/deductions',
            cartLoading: 'cart/cartLoading',
            cartActionLoading: 'cart/cartActionLoading',
            cart: 'cart/cart',
            errors: 'auth/errors',
        }),
    },
    watch: {
        cart: function(reg){
            if (reg != null && reg.details != null) {
                this.cartDetail = []
                reg.details.forEach(el => {
                    let item = {
                        'codigo':   el.codarticulo,
                        'precio':   el.precio_unitario,
                        'cantidad': el.cantidad,
                        'modelo': el.modelo,
                    }
                    this.cartDetail.push(item)
                });
                this.pagoAnticipado = reg.cart.pago_anticipado === 1 ? true : false
                this.compareCarts()
            }
        },
    },
    methods: {
        ...mapActions({
            updateCart:     'cart/updateCart',
            removeItem:     'cart/deleteItemFromCart',
            setPrepaid:     'cart/setPrepaid',
            setPayment:     'cart/setPayment',
            setObservation: 'cart/setObservation',
            deleteCart:     'cart/deleteCart',
            confirmCart:    'cart/confirmCart',
        }),
        add(codigo){
            this.updateItem(codigo, 'add')
        },
        remove(codigo){
            this.updateItem(codigo, 'remove')
        },
        confirmCustomDelete(codigo) {
            this.$buefy.dialog.confirm({
                title: 'Eliminar Item',
                message: 'Esta seguro que quiere <b>Eliminar</b> este item? Esta acción no se puede revertir.',
                confirmText: 'Eliminar Item',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => this.removeItem(codigo)
            })
        },
        checkAndConfirmCart(){
            if (!this.formaPago){
                this.$buefy.dialog.alert({
                    title: 'Atención!',
                    message: 'Debe seleccionar una forma de pago.',
                    type: 'is-danger',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return false
            }
            this.confirmCart()
        },
        compareCarts(){
            let objectsAreSame = true;
            for (let el1 of this.cart.details) {
                let res =  this.cartDetail.filter( el2 => {
                    return el2.codigo == el1.codarticulo
                })
                if( el1.cantidad != res[0].cantidad ){
                    objectsAreSame = false
                    break
                }
            }
            this.cartEquals = objectsAreSame
        },
        updateItem(codigo, action, value ){
            this.cartDetail.forEach(el => {
                if( el.codigo == codigo){
                    if (action === 'change') {
                        value = (value == 0) ? 1 : value
                        el.cantidad = value
                    }
                    if (action === 'add') {
                        el.cantidad++
                    }
                    if (action === 'remove' && el.cantidad > 1) {
                        el.cantidad--
                    }
                }
            })
            this.compareCarts()
        },
        handleKeydown(text) {
            this.setObservation(text)
        }
    }
}
</script>

<style>
.table-container{
    width: 100%;
    padding: 30px;
}
.table-wrapper{
    overflow-x: auto;
}

input.spinner-value{
    border: none;
    max-width: 30px;
    text-align: center;
    color: #4a4a4a;
    font-size: 1em;
}

.cart-order-summary {
    height: auto;
    min-height: unset;
    max-height: unset;
    padding: 20px;
    font-size: 0.9em;
    line-height: 1;
}

.cart-order-summary .summary-header {
    font-size: .9rem;
    font-family: "Montserrat",sans-serif;
    font-weight: 600;
    color: #999;
}
.cart-order-summary .summary-header.header-only{
    padding-bottom: 16px;
}
.cart-order-summary .summary-header:not(:first-of-type) {
    border-top: 1px solid rgba(153, 153, 153, 0.25);
    padding-top: 10px;
}

.cart-order-summary .cart-summary-list .summary-item span.discount:before {
    content: "%";
}

.cart-order-summary .cart-summary-list .summary-item.active span{
    color: #23d160 !important;
    font-weight: bold;
}

.button-wrap div.button-container{
    width: 50%;
    float: left;
    padding: 0 3px;
}
.button-wrap div .button.delete-button{
    outline: none;
    border-color: #ff3b3c;
    background-color: #ff3b3c;
    color: #fff;
    transition: all 0.5s;
}
</style>
